'use strict';

import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';

var Tabs = Backbone.View.extend({
  dom: {},
  events: {
    'click .TabsContainer-headingwrapper .Tab': 'tabClicked',
    'change .TabsContainer-headingwrapper-mobiledropdown-select': 'tabSelectedInDropdown'
  },

  initialize: function() {
    this.cacheDom();
    this.processTabs();
  },

  cacheDom: function() {
    this.dom = {};
    this.dom.tabGroups = $('.TabsContainer')
  },

  processTabs: function() {
    var outerThis = this;
    this.dom.tabGroups.each(function(i, element) {
      var $tabGroup = $(element),
        $tabButtons = $tabGroup.find('.TabsContainer-headingwrapper .Tab-buttonwrapper-button'),
        tabData = outerThis.getTabData($tabButtons);
      outerThis.renderSelect($tabGroup, tabData);
      outerThis.setActiveTab($tabGroup, 0);
    });
  },

  renderSelect: function(tabGroup, tabData) {
    var select = tabGroup.find('.TabsContainer-headingwrapper-mobiledropdown-select');

    tabData.forEach(function(tab) {
      var option = $('<option />')
        .text(tab.tabLabel);

      select.append(option);
    });
  },

  getTabData: function(tabs) {
    var data = [];

    tabs.each(function(i, tab) {
      data.push($(tab).data());
    });

    return data;
  },

  tabSelectedInDropdown: function(e) {
    var $option = $(e.currentTarget),
      $tabGroup = $option.parents('.TabsContainer'),
      index = $option[0].selectedIndex;

    this.setActiveTab($tabGroup, index, false);
  },

  tabClicked: function(e) {
    var $tab = $(e.currentTarget),
      index = $tab.index(),
      $tabGroup = $tab.parents('.TabsContainer');
    this.setActiveTab($tabGroup, index);
  },

  setActiveTab: function($tabGroup, i) {
    var index = i || 0,
      $activeTabs = $tabGroup.find('.Tab.active'),
      $tabInHeading = $tabGroup.find('.TabsContainer-headingwrapper-list .Tab').eq(index),
      $tabInContent = $tabGroup.find('.TabsContainer-tabs .Tab').eq(index);


    $activeTabs.removeClass('active');
    $tabInHeading.addClass('active');
    $tabInContent.addClass('active');
  }
});


Tabs.extend = function(child) {
  let view = Backbone.View.extend.apply(this, arguments);
  view.prototype.events = _.extend({}, this.prototype.events, child.events);
  return view;
};

export function createTabs($parent) {
  $parent.find('.TabsContainer').each((i, $tabContainer) => {
    new Tabs({
      el: $tabContainer
    })
  });
}

export default Tabs;



// WEBPACK FOOTER //
// ./assets/components/Tabs/Tabs.js